import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import "./index.css"

import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog";
import { InputText } from 'primereact/inputtext';
import { DataView } from 'primereact/dataview';

import { fetchOrderHistory, updateSearchParams } from "../../../services/redux/reducers/orderHistory/orderHistory";
import { fetchMaterialsData } from '../../../services/redux/reducers/Requirement/requirement';
import { fetchOrderTypesData, fetchLogisticPartners } from '../../../services/redux/reducers/commonThunk';

import OrderItemTemplate from './components/OrderItemTemplate';
import { isMobile } from '../../../utils';
import PurchaseOrderMobileSkeleton from '../../../skeletons/PurchaseOrderMobile';
import PurchaseOrderDesktopSkeleton from '../../../skeletons/PurchaseOrderDesktop';


const OrderHistory = () => {
    const materialProductsData = useSelector(state => state.requirements.materialProductsData)
    const orderHistoryList = useSelector(state => state.orderHistory.orderHistoryList)
    const isLoading = useSelector(state => state.orderHistory.loading)
    const paginationParams = useSelector(state => state.orderHistory.paginationParams)
    const searchParams = useSelector(state => state.orderHistory.searchParams)
    const userDetails = useSelector(state => state.userDetails)

    const [isTrackingDetailsVisible, setIsTrackingDetailsVisible] = useState(false)
    const [displayedTrackingDetails, setDisplayedTrackingDetails] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchLogisticPartners())
        dispatch(fetchOrderTypesData())

        let branchIds = []
        let companyIds = []
        if (userDetails?.activeUserRoleDetails?.branchId) {
            branchIds.push(userDetails?.activeUserRoleDetails?.branchId)
        } else {
            companyIds.push(userDetails?.activeUserRoleDetails?.companyId)
        }
        dispatch(updateSearchParams({ ...searchParams, branchIds, companyIds }))
        dispatch(fetchOrderHistory({ ...paginationParams, ...searchParams, branchIds, companyIds, pageNo: 0 }))
    }, [userDetails])

    useEffect(() => {
        if (orderHistoryList.length > 0) {
            let buyerReqItemIds = []
            orderHistoryList?.map(eachInvoice => {
                eachInvoice?.buyerInvoiceItems?.map(eachInvoiceItem => {
                    if (eachInvoiceItem?.buyerReqItemId && !buyerReqItemIds.includes(eachInvoiceItem?.buyerReqItemId)) {
                        buyerReqItemIds.push(eachInvoiceItem?.buyerReqItemId)
                    }
                })
            })
            let materialIdParams = {
                buyerReqItemsIds: buyerReqItemIds
            }

            dispatch(fetchMaterialsData(materialIdParams))
        }
    }, [orderHistoryList])

    const handleTrackingDetailsView = (row) => {
        const trackingDetails = []
        row.invoiceDispatchMap.map(eachDispatchNoteMap => {
            if (eachDispatchNoteMap.dispatchNote?.trackingNumber) {
                trackingDetails.push(eachDispatchNoteMap.dispatchNote)
            }
        })

        setIsTrackingDetailsVisible(true)
        setDisplayedTrackingDetails(trackingDetails)
    }

    const handlePageChange = async (e) => {
        let paginatorParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        dispatch(fetchOrderHistory(paginatorParams))
    }

    const orderTemplate = (row) => {
        return (
            <OrderItemTemplate
                invoice={row}
                materialProductsData={materialProductsData}
                handleTrackingDetailsView={handleTrackingDetailsView}
            />
        )
    }

    const handleSearchTextChange = (event) => {
        let eventValue = event.target.value
        const updatedSearchParams = { ...searchParams, [event.target.name]: eventValue }
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const handleSearch = () => {
        const updatedSearchParams = { ...searchParams }
        if (searchParams.searchText.trim() === "") {
            updatedSearchParams.searchBy = "all"
        } else {
            updatedSearchParams.searchBy = "docNo"
        }
        dispatch(fetchOrderHistory({ ...paginationParams, ...updatedSearchParams, pageNo: 0 }))
    }

    if (isLoading) {
        return (
            isMobile() ? <PurchaseOrderMobileSkeleton /> : <PurchaseOrderDesktopSkeleton />
        )
    }

    return (
        <div className="order-history-layout flex flex-column">
            <Toast ref={Toast} />

            <div className="flex flex-column md:flex-row md:justify-content-between invoices-header-section" >
                <h3 className="m-2" style={{ borderBottom: "2px solid #0da487" }}>Invoices</h3>

                <div className="catalogue-request-search md:w-5 p-input-icon-right">
                    <div className="flex flex-row justify-content-center align-items-center"
                        style={{ position: "absolute", width: "50px", height: "45px", right: 0, backgroundColor: "#ffa53b", borderTopRightRadius: "6px", borderBottomRightRadius: "6px", cursor: "pointer" }}
                        onClick={handleSearch}
                    >
                        <i className="pi pi-search" style={{ color: "white", fontSize: "17px", marginTop: "3px" }} />
                    </div>
                    <InputText placeholder="Enter document number" value={searchParams["searchText"]} style={{ width: "100%", height: "45px", fontSize: "16px", borderColor: "#ececec" }} name="searchText" onChange={(e) => handleSearchTextChange(e)} />
                </div>

                <div className="flex w-1">
                </div>
            </div>

            <div className='flex flex-row invoices-table-container'>
                <div className="open-po-table" style={{ order: "1", width: "100%" }}>
                    <div className=''>
                        <DataView
                            value={orderHistoryList}
                            totalRecords={paginationParams?.totalRecords}
                            itemTemplate={orderTemplate}
                            paginator
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            currentPageReportTemplate=""  // {first} to {last} of {totalRecords}
                            rows={paginationParams.recordsPerPage}
                            loading={isLoading}
                            onPage={e => handlePageChange(e)}
                            page={paginationParams.pageNo}
                            first={paginationParams.pageNo * paginationParams.recordsPerPage}
                            lazy
                        />
                    </div>
                </div>
            </div>

            <Dialog header="Tracking Details" visible={isTrackingDetailsVisible} style={{ width: '45vw', height: '30vh' }} onHide={() => { setIsTrackingDetailsVisible(false); setDisplayedTrackingDetails([]) }}>
                <div className="ml-2 mr-2 mt-0 pt-0">
                    <div>
                        <div className="flex justify-content-between">
                            <div className="flex flex-wrap py-2 w-full">
                                <div className="flex justify-content-between flex-grow-1 font-bold header-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "14px" }}>
                                    <div className="mt-1" style={{ width: '33%' }}>Tracking Number</div>
                                    <div className="mt-1" style={{ width: '33%' }}>Tracking Order Link</div>
                                    <div className="mt-1" style={{ width: '34%' }}>Document</div>
                                </div>
                                {
                                    displayedTrackingDetails?.map(eachTrackingDetails => {
                                        return (
                                            <div className="flex justify-content-between flex-grow-1 w-full data-style" style={{ borderBottom: '1px solid rgb(217 227 222)', fontSize: "13px" }}>
                                                <div className="py-1 align-self-center" style={{ width: '33%' }}>{eachTrackingDetails?.trackingNumber}</div>
                                                <div className="py-1 align-self-center" style={{ width: '33%' }}>
                                                    {eachTrackingDetails?.trackingOrderLink ? <a href={eachTrackingDetails.trackingOrderLink} target="_blank" >View</a> : ""}
                                                </div>
                                                <div className="py-1 align-self-center" style={{ width: '34%' }}>
                                                    {eachTrackingDetails?.trackingDocPath ? <a href={eachTrackingDetails.trackingDocPath} target="_blank" >View</a> : ""}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>

    )

}

export default OrderHistory